import { EnvironmentGroupId } from '../../types';

export const queryKeys = {
  base: () => ['environment-groups'] as const,
  list: (size: boolean = false) => [...queryKeys.base(), { size }] as const,
  group: (id?: EnvironmentGroupId, size: boolean = false) =>
    [...queryKeys.base(), 'item', id, { size }] as const,
};
